import React, { useEffect } from 'react'
import { Button, Heading, IconAvatar, Link, Money, Skeleton, Text } from '@afterpaytouch/core'
import { Head } from '../../component'
import { Route } from '../../config/router'
import { TrackPageViewed } from '../../integrations/monitoring'
import { CheckoutPage } from '../../model'
import { setWelcomeWithInitialLimitSeen, useAppDispatch, useAppRouter, useGetCreditLimitQuery } from '../../state'
import { useCheckoutSizes } from '../../utils/responsive'
import { Trans, useTranslation } from '../../utils/convergence'
import styles from './styles.module.css'

export const WelcomeWithInitialLimitPage: CheckoutPage = () => {
  const router = useAppRouter()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const { headingSize, textSize } = useCheckoutSizes()
  const { data: creditLimitData, isLoading, isError } = useGetCreditLimitQuery()

  const handleContinue = (): void => {
    dispatch(setWelcomeWithInitialLimitSeen())
    router.replace(Route.LOGGED_IN)
  }

  useEffect(() => {
    if (isError) {
      dispatch(setWelcomeWithInitialLimitSeen())
      router.replace(Route.LOGGED_IN)
    }
  }, [isError, dispatch, router])

  if (isError) {
    return null
  }

  return (
    <div className={styles.container}>
      <Head title={t('welcomeWithInitialLimit:heading')} />
      <div className={styles.icon}>
        <IconAvatar iconName='Check' backgroundColor='Bondi Mint' size='L' testNameSpace='welcome-check-icon' />
      </div>
      <div className={styles.heading}>
        <Heading size={headingSize}>{t('welcomeWithInitialLimit:heading')}</Heading>
      </div>
      <div className={styles.subtitle}>
        <Text size={textSize} color='Subtle'>
          {t('welcomeWithInitialLimit:estimatedSpend')}
        </Text>
      </div>
      <div className={styles.amount}>
        <Heading renderAs='span' size={headingSize}>
          <span className={isLoading ? styles.visuallyInvisible : ''}>
            {creditLimitData?.creditLimit != null &&
              Money({
                amount: creditLimitData.creditLimit.amount,
                currency: creditLimitData.creditLimit.currency,
                locale: router.locale,
              })}
          </span>
          {isLoading && <Skeleton />}
        </Heading>
      </div>
      <div className={styles.sections}>
        <div className={styles.sectionTitle}>
          <Text size={textSize} bold>
            {t('welcomeWithInitialLimit:uniqueAmountTitle')}
          </Text>
        </div>
        <div className={styles.sectionBody}>
          <Text size={textSize} color='Subtle'>
            <Trans
              i18nKey='welcomeWithInitialLimit:uniqueAmountBody'
              components={{
                clickHereLink: <Link kind='Underline' href={t('common:spendLimitInfoUrl')} target='_blank' />,
              }}
            />
          </Text>
        </div>
        <div className={styles.sectionTitle}>
          <Text size={textSize} bold>
            {t('welcomeWithInitialLimit:justSoYouKnowTitle')}
          </Text>
        </div>
        <div className={styles.sectionBody}>
          <Text size={textSize} color='Subtle'>
            {t('welcomeWithInitialLimit:justSoYouKnowBody')}
          </Text>
        </div>
      </div>
      <div className={styles.cta}>
        <Button.Primary size='Large' padding='Fluid' onClick={handleContinue} testNameSpace='welcome-continue'>
          {t('welcomeWithInitialLimit:continue')}
        </Button.Primary>
      </div>
      <TrackPageViewed />
    </div>
  )
}
